import { useState, useEffect } from "react";
import { Palette } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const THEMES = [
  { key: "light", label: "Light" },
  { key: "dark", label: "Dark" },
  { key: "moderate", label: "Moderate" },
  { key: "blue", label: "Deep Blue" },
  { key: "emerald", label: "Emerald" },
  { key: "purple", label: "Royal Purple" },
  ];

export function applyTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme || "light");
}

export default function ThemeSwitcher() {
  const [theme, setTheme] = useState(() => localStorage.getItem("app_theme") || "light");

  useEffect(() => { applyTheme(theme); localStorage.setItem("app_theme", theme); }, [theme]);

  return (
    <div className="flex items-center gap-1.5" data-testid="theme-switcher">
      <Palette size={16} className="text-slate-400" />
      <Select value={theme} onValueChange={setTheme}>
        <SelectTrigger className="h-9 w-[130px]" data-testid="theme-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          {THEMES.map((t) => <SelectItem key={t.key} value={t.key} data-testid={`theme-${t.key}`}>{t.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
